import { useState, useEffect, useCallback } from 'react';
import Utils from '../../services/Utils';

const useScrollDetection = (elementRef) => {
  const [scrollState, setScrollState] = useState({
    hasHorizontalScroll: false,
    hasVerticalScroll: false,
    isAtTop: true,
    isAtBottom: false,
    isAtLeft: true,
    isAtRight: false,
  });

  const checkScrollPosition = useCallback(Utils.debounce(() => {
    if (!elementRef.current) return;
    const { scrollTop, scrollHeight, clientHeight, scrollLeft, scrollWidth, clientWidth } = elementRef.current;

    setScrollState({
      hasHorizontalScroll: scrollWidth > clientWidth,
      hasVerticalScroll: scrollHeight > clientHeight,
      isAtTop: scrollTop === 0,
      isAtBottom: scrollTop + clientHeight >= scrollHeight,
      isAtLeft: scrollLeft === 0,
      isAtRight: scrollLeft + clientWidth >= scrollWidth,
    });
  }, 100), [elementRef]);

  useEffect(() => {
    const element = elementRef.current;

    if (element) {
      checkScrollPosition();
      element.addEventListener('scroll', checkScrollPosition);
      window.addEventListener('resize', checkScrollPosition);

      return () => {
        element.removeEventListener('scroll', checkScrollPosition);
        window.removeEventListener('resize', checkScrollPosition);
      };
    }
  }, [elementRef.current, checkScrollPosition]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (elementRef.current) {
        checkScrollPosition();
        clearInterval(interval);
      }
    }, 100);
  }, [elementRef, checkScrollPosition]);

  return { ...scrollState, checkScrollPosition };
};

export default useScrollDetection;
